import { BaseService } from "./base.service";
export class ProgramRatingsService extends BaseService {
  constructor() {
    super("program-ratings");
  }
}
